import { render, staticRenderFns } from "./ProPlan.vue?vue&type=template&id=788c6b94&scoped=true&"
import script from "./ProPlan.vue?vue&type=script&lang=js&"
export * from "./ProPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c6b94",
  null
  
)

export default component.exports